import React from 'react';

import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import Dialog from 'shared/dialog';

interface Props {
  show: boolean;
  onDelete: () => void;
  onHide: () => void;
}

export default function DeleteModal({ show, onDelete, onHide, ...props }: Props) {
  async function handleDelete() {
    await onDelete();
    onHide();
  }

  return (
    <Dialog
      {...props}
      buttonType="danger"
      confirmLabel="Delete"
      headerText="Delete Task"
      icon={faExclamationCircle}
      iconClassName="text-danger"
      show={show}
      onConfirm={handleDelete}
      onHide={onHide}
    >
      <h3 className="m-0">Are you sure you want to delete this task?</h3>
    </Dialog>
  );
}
